var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#clip0)"},React.createElement("path",{"fill":"red","d":"M31.333 8.676a3.715 3.715 0 00-1.021-1.693 4.066 4.066 0 00-1.784-.99c-2.504-.66-12.536-.66-12.536-.66-4.182-.047-8.364.162-12.52.627a4.213 4.213 0 00-1.784 1.013A3.862 3.862 0 00.65 8.675 38.787 38.787 0 000 16a38.717 38.717 0 00.65 7.325 3.77 3.77 0 001.034 1.692c.495.471 1.11.811 1.788.991 2.537.659 12.52.659 12.52.659 4.187.047 8.374-.162 12.536-.627a4.067 4.067 0 001.784-.99 3.706 3.706 0 001.02-1.693A37.83 37.83 0 0032 16.031a35.434 35.434 0 00-.667-7.356v.001zm-18.53 11.89v-9.13l8.346 4.565-8.347 4.564z"})));
}

Youtube.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = Youtube;

Youtube.default = Youtube;
